import { render } from "./ChatUserById.vue?vue&type=template&id=1cb2269e&scoped=true"
import script from "./ChatUserById.vue?vue&type=script&lang=js"
export * from "./ChatUserById.vue?vue&type=script&lang=js"

import "./ChatUserById.vue?vue&type=style&index=0&id=1cb2269e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb2269e"]])

export default __exports__